import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import HostnameRedirect from "./components/HostnameRedirect";
import SiteLayout from "./components/layout/SiteLayout";
import AdminLayout from "./components/layout/AdminLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import ServiceDetail from "./pages/ServiceDetail";
import CityServiceDetail from "./pages/CityServiceDetail";
import SubBrand from "./pages/SubBrand";
import Sectors from "./pages/Sectors";
import Projects from "./pages/Projects";
import ComplianceHub from "./pages/ComplianceHub";
import ComplianceDetail from "./pages/ComplianceDetail";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Coverage from "./pages/Coverage";
import Accreditations from "./pages/Accreditations";
import Contact from "./pages/Contact";
import PoliciesIndex from "./pages/PoliciesIndex";
import Policy from "./pages/Policy";
import AdminLogin from "./pages/admin/Login";
import AdminDashboard from "./pages/admin/Dashboard";
import AdminEnquiries from "./pages/admin/Enquiries";
import AdminUsers from "./pages/admin/Users";
import AdminBlog from "./pages/admin/Blog";
import AdminTraining from "./pages/admin/Training";
import ChangePassword from "./pages/admin/ChangePassword";
import StaffDetail from "./pages/admin/StaffDetail";
import QuoteView from "./pages/admin/QuoteView";
import AuditLog from "./pages/admin/AuditLog";
import QuoteAccept from "./pages/QuoteAccept";
import StaffPortal from "./pages/staff/Portal";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <HostnameRedirect />
        <ScrollToTop />
        <Toaster position="top-right" theme="dark" richColors />
        <Routes>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/services/:slug/:city" element={<CityServiceDetail />} />
            <Route path="/brands/:slug" element={<SubBrand />} />
            <Route path="/sectors" element={<Sectors />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/compliance-hub" element={<ComplianceHub />} />
            <Route path="/compliance-hub/:slug" element={<ComplianceDetail />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/coverage" element={<Coverage />} />
            <Route path="/coverage/:slug" element={<Coverage />} />
            <Route path="/accreditations" element={<Accreditations />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/policies" element={<PoliciesIndex />} />
            <Route path="/policies/terms-of-service" element={<Navigate to="/termsofservice" replace />} />
            <Route path="/policies/environmental-plan" element={<Navigate to="/environmental-plan" replace />} />
            <Route path="/policies/:slug" element={<Policy />} />
            <Route path="/environmental-plan" element={<Policy slug="environmental-plan" />} />
            <Route path="/termsofservice" element={<Policy slug="terms-of-service" />} />

            {/* Legacy greensurv.co.uk URL aliases — preserve SEO when old URLs redirect here */}
            <Route path="/faq" element={<Navigate to="/" replace />} />
            <Route path="/post/dutyholder-responsibilities-explained" element={<Navigate to="/blog" replace />} />
            <Route path="/post/what-is-an-asbestos-management-survey-and-when-is-it-required" element={<Navigate to="/services/asbestos" replace />} />
            <Route path="/post/:slug" element={<Navigate to="/blog" replace />} />
            <Route path="/our-services/water-safety-and-water-hygiene/water-hygiene-compliance" element={<Navigate to="/services/water-hygiene" replace />} />
            <Route path="/our-services/water-safety-and-water-hygiene/*" element={<Navigate to="/services/water-hygiene" replace />} />
            <Route path="/our-services/fire-safety-and-compliance-services/fire-extinguisher-servicing" element={<Navigate to="/services/fire-safety" replace />} />
            <Route path="/our-services/fire-safety-and-compliance-services/*" element={<Navigate to="/services/fire-safety" replace />} />
            <Route path="/our-services/asbestos-surveys-and-compliance/*" element={<Navigate to="/services/asbestos" replace />} />
            <Route path="/our-services/*" element={<Navigate to="/services" replace />} />
          </Route>

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/q/:token" element={<QuoteAccept />} />
          <Route path="/admin/change-password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

          <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/enquiries" element={<AdminEnquiries />} />
            <Route path="/admin/quotes/:id" element={<QuoteView />} />
            <Route path="/admin/users" element={<ProtectedRoute requireAdmin><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/staff/:id" element={<ProtectedRoute requireAdmin><StaffDetail /></ProtectedRoute>} />
            <Route path="/admin/audit-log" element={<ProtectedRoute requireAdmin><AuditLog /></ProtectedRoute>} />
            <Route path="/admin/blog" element={<ProtectedRoute requireAdmin><AdminBlog /></ProtectedRoute>} />
            <Route path="/admin/training" element={<AdminTraining />} />
            <Route path="/staff" element={<StaffPortal />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
